import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { useHemocultureAuthStore } from '../stores/hemoculture-auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'hemoculture-dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'hemoculture-dashboard' },
    children: [
      {
        name: 'hemoculture-dashboard',
        path: 'hemoculture/dashboard',
        component: () => import('../pages/hemoculture/DashboardHemoculture.vue'),
      },
      {
        name: 'hemoculture-submissions-admin',
        path: 'hemoculture/soumissions',
        component: () => import('../pages/hemoculture/SubmissionsAdminPage.vue'),
      },
      {
        name: 'hemoculture-submission',
        path: 'hemoculture/soumettre',
        component: () => import('../pages/hemoculture/SubmissionPage.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to) => {
  const authStore = useHemocultureAuthStore()
  const isAuthenticated = Boolean(authStore.token || localStorage.getItem('hemoculture-token'))

  if (to.name === 'login' && isAuthenticated) {
    return { name: 'hemoculture-dashboard' }
  }

  if (to.path.startsWith('/auth')) {
    return true
  }

  if (!isAuthenticated) {
    return { name: 'login' }
  }

  if (!authStore.user) {
    try {
      await authStore.fetchCurrentUser()
    } catch {
      authStore.clearSession()
      return { name: 'login' }
    }
  }

  return true
})

export default router
